import React, { useState, useEffect, useMemo, ChangeEvent } from 'react'

import { Box, Button, Paper, useTheme, Typography, Icon, TextField, IconButton, LinearProgress, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Pagination, ClickAwayListener, CircularProgress } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import jwt_decode from "jwt-decode";

import { LayoutBaseDePagina } from '../../shared/layouts'
import { AutoCompleteDeSetor } from '../../shared/components/autocompletes/AutoCompleteDeSetor';
import { ITipo_Indice_Documento, Tipo_Indice_Service } from '../../shared/services/api/tipo_indice/Tipo_Indice_Service';
import { IListagemTipo, TipoService } from '../../shared/services/api/tipo/TipoService';
import { DocumentoService, IDocumento, IIndice_Documento, IEmail, IAlterarTipoDocumentoPayload } from '../../shared/services/api/documento/DocumentoService';
import { Environment } from '../../shared/environment';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { useSearchParams } from 'react-router-dom';
import { AlertSnackBar } from '../../shared/components';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

import { useAppThemeContext } from '../../shared/contexts';
import { IndicesCadastro } from '../../shared/components/indices/IndicesCadastro';
import { ConversorDeValorIndice } from '../../shared/components/indices/ConversorDeValorIndice';
import { CampoTextoMascarado } from '../../shared/components/campo-texto-mascarado/CampoTextoMascarado';

import { CircularProgressWithLabel } from '../../shared/components/circular-progress-with-label/CircularProgressWithLabel';
import { AbrirDocumento } from '../../shared/components/visualizador-de-documento/AbrirDocumento';
import { ListagemTipos } from '../../shared/components/dialog/tipos/ListagemTipos';
import { AlterarTipo } from '../../shared/components/dialog/alterar-tipo/AlterarTipo';

export const ConsultaDeDocumento: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const theme = useTheme();

    const { themeName } = useAppThemeContext();

    const pagina = useMemo(() => {
        return Number(searchParams.get('pagina') || '1');
    }, [searchParams]);

    const [idSetor, setIdSetor] = useState<number | undefined>(undefined);
    useEffect(() => { setIdSetor(Number(localStorage.getItem("idSetor"))) }, [])

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [paginacao, setPaginacao] = useState<IPaginacao>({
        totalCount: 0,
        pageSize: 0,
        currentPage: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false
    });
    const [isLoading, setIsLoading] = useState(false);

    function resetPaginacao() {
        setPaginacao({
            totalCount: 0,
            pageSize: 0,
            currentPage: 0,
            totalPages: 0,
            hasNext: false,
            hasPrevious: false
        });
    }

    function limparCamposPesquisa() {
        setTextoBusca('');
        setLocalizador('');
    }

    const [rows, setRows] = useState<IDocumento[]>([]);
    const [escolha, setEscolha] = useState<string>("");

    const [openDialogMesclar, setOpenDialogMesclar] = useState(false);
    const [isLoadingMesclar, setIsLoadingMesclar] = useState(false);
    const [selectedIdDoc, setSelectedIdDoc] = useState(0);

    const handleClickOpenMesclar = () => {
        setOpenDialogMesclar(true);
    };
    const handleCloseMesclar = () => {
        setOpenDialogMesclar(false);
    };

    const [openConfirmarVoltarVersao, setOpenConfirmarVoltarVersao] = useState(false);

    const handleClickOpenVoltarVersao = () => {
        setOpenConfirmarVoltarVersao(true);
    };
    const handleCloseVoltarVersao = () => {
        setOpenConfirmarVoltarVersao(false);
    };

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);

    //@ts-expect-error
    const handleArquivo = (event) => {
        if (!!event.target.files[0]) {
            setSelectedFile(event.target.files[0]);
            setIsFilePicked(true);
        }
    };


    const [localizador, setLocalizador] = useState('');
    const [helperTextLocalizador, setHelperTextLocalizador] = useState(false);
    const [tipoMascara, setTipoMascara] = useState("aa9-999-a-999");
    const [showTooltipMascara, setShowTooltipMascara] = useState(false);

    const [helperTextCodBarras, setHelperTextCodBarras] = useState(false);
    const [codBarras, setCodBarras] = useState("");

    const [progressLoading, setProgressLoading] = useState(Array(rows.length).fill(0)); 

    const handleTooltipMascaraClose = () => {
        setShowTooltipMascara(false);
    };

    const handleTooltipMascaraOpen = () => {
        setShowTooltipMascara(true);
    };

    const [textoBusca, setTextoBusca] = useState('');
    const [helperTextTextoBusca, setHelperTextTextoBusca] = useState(false);

    const handleChangeLocalizador = (valorMascarado: string) => {
        setLocalizador(valorMascarado.toUpperCase());// colocar todas as letras digitas em maiúsculo
    };

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.background.paper,
            color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
            maxWidth: 220,
            border: '1px solid #dadde9',
        },
    }));

    //-------------------------------------------------------------------------------------  Parte dos tipos -------------------------------------------------------------------------------------
    const [rowsTipo, setRowsTipo] = useState<IListagemTipo[]>([]);
    const [openDialogTipo, setOpenDialogTipo] = useState(false);

    const [selectedIdTipo, setSelectedIdTipo] = useState<number>(0);

    const handleClickOpenTipo = () => {
        setOpenDialogTipo(true);
    };

    const handleCloseTipo = () => {
        setOpenDialogTipo(false);
    };

    useEffect(() => {
        // if (idSetor !== undefined && idSetor !== null && idSetor !== 0) {
        //     setRowsTipo([]);
        // } else {
            setRowsTipo([]);
            setSelectedIdTipo(0);
        // }
    }, [idSetor]);

    //-------------------------------------------------------------------------------  Fim da parte dos tipos -------------------------------------------------------------------------------
    //----------------------------------------------------------------------------------  Parte dos índices ---------------------------------------------------------------------------------
    const [isLoadingIndice, setIsLoadingIndice] = useState(false);
    const [openDialogIndice, setOpenDialogIndice] = useState(false);
    const [openDialogAlterarValorIndice, setOpenDialogAlterarValorIndice] = useState(false);

    const [prevSelectedIdTipo, setPrevSelectedIdTipo] = useState<number>(-1);// inicializar em um valor diferente do tipo selecionado

    const handleClickOpenIndice = () => {
        if (selectedIdTipo !== 0 && selectedIdTipo !== prevSelectedIdTipo) {
            setPrevSelectedIdTipo(selectedIdTipo);
            setRowsIndice([]);
            setValores([]);
            setIsLoadingIndice(true);
            Tipo_Indice_Service.getByIdTipo(selectedIdTipo, false).then((result) => {
                setIsLoadingIndice(false);
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setRowsIndice(result);
                    setResetIndices(true);
                    setTimeout(() => setResetIndices(false), 0);
                }
            });
        }
        setOpenDialogIndice(true);
    };

    const handleCloseIndice = () => {
        setOpenDialogIndice(false);
    };

    const [migracao, setMigracao] = useState(false);
    const [idTipoOrigemMigracao, setIdTipoOrigemMigracao] = useState<number>(0);

    const handleClickOpenAlterarTipo = (idDoc: number, idTipoDoc: number) => {
        setSelectedIdDoc(idDoc);
        setIdTipoOrigemMigracao(idTipoDoc);
        setMigracao(true);
    };

    const handleConfirmarAlterarTipo = (dados: IAlterarTipoDocumentoPayload) => {
        DocumentoService.alterarTipo(dados).then((result) => {
            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
                return;
            }

            setRows((prevRows) => prevRows.map((row) => {
                if (row.idDocumento !== dados.idDocumento) {
                    return row;
                }

                return {
                    ...row,
                    idTipo: dados.idTipo,
                    indice_documentos: dados.indice_documentos,
                };
            }));

            setMigracao(false);
            setIdTipoOrigemMigracao(0);

            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Tipo do documento alterado com sucesso" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        });
    };

    const handleClickOpenAlterarValorIndice = (idDoc: number, idTipoDoc: number) => {
        setRowsAlterarValorIndice([]);
        setValoresAlterar([]);
        setIsLoadingIndice(true);

        Tipo_Indice_Service.getByIdTipo(idTipoDoc, false).then((result) => {
            setIsLoadingIndice(false);
            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                var rowDoc = rows.filter(row => row.idDocumento === idDoc);
                var valores = rowDoc[0].indice_documentos.map(indice_documento => ConversorDeValorIndice.paraValorUI(indice_documento));
                setValoresAlterar(valores);

                setRowsAlterarValorIndice(result);
            }
        });

        setOpenDialogAlterarValorIndice(true);
    };

    const handleCloseAlterarValorIndice = () => {
        setOpenDialogAlterarValorIndice(false);
    };

    const [rowsIndice, setRowsIndice] = useState<ITipo_Indice_Documento[]>([]);
    const [valores, setValores] = useState<string[]>([]);
    const [resetIndices, setResetIndices] = useState(false);

    const [rowsAlterarValorIndice, setRowsAlterarValorIndice] = useState<ITipo_Indice_Documento[]>([]);
    const [valoresAlterar, setValoresAlterar] = useState<string[]>([]);
    const [isLoadingAlterarValorIndice, setIsLoadingAlterarValorIndice] = useState<boolean>(false);

    const handleSaveAlterarIndices = () => {
        setIsLoadingAlterarValorIndice(true);
        var podeSalvar = true;

        if (valoresAlterar.every(elemento => elemento === '')) { podeSalvar = false; }

        if (!podeSalvar) {
            setIsLoadingAlterarValorIndice(false);
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha no mínino um indice" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else {
            var dadosIndice: IIndice_Documento[] = ConversorDeValorIndice
                .paraPayload(rowsAlterarValorIndice, valoresAlterar)
                .map((payload) => ({ ...payload, idDocumento: selectedIdDoc }));

            DocumentoService.createIndice_Documento(dadosIndice).then((result) => {
                setIsLoadingAlterarValorIndice(false);
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    var rowDoc = rows.filter(row => row.idDocumento === selectedIdDoc)[0];
                    var index = rows.indexOf(rowDoc);

                    setRows((prevRows) => {
                        const newRows = [...prevRows];
                        newRows[index].indice_documentos = dadosIndice;
                        return newRows;
                    });

                    handleCloseAlterarValorIndice();
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Indices alterados com sucesso" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
            });
        }

    }


    //------------------------------------------------------------------------------  Fim da parte dos índices ------------------------------------------------------------------------------


    const handleConsultarPorIdTipo = (isNewPage: boolean | undefined) => {
        handleCloseTipo();
        setRows([]);
        resetPaginacao()
        setIsLoading(true);

        if (isNewPage) {
            DocumentoService.consultarPorIdTipo(selectedIdTipo, pagina).then(result => {
                setIsLoading(false);
                if (result instanceof Error) {//verificar se deu erro
                    setIsLoading(false);
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setRows(result.documentos)
                    setPaginacao(result.paginacao);
                    setEscolha("tipo");
                }
            });
        } else {
            limparCamposPesquisa();
            setSearchParams({ pagina: "1" }, { replace: true })
            DocumentoService.consultarPorIdTipo(selectedIdTipo, 1).then(result => {
                setIsLoading(false);
                if (result instanceof Error) {//verificar se deu erro
                    setIsLoading(false);
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setRows(result.documentos)
                    setPaginacao(result.paginacao);
                    setEscolha("tipo");
                }
            });
        }
    }

    const handleConsultarPorIndices = (isNewPage: boolean | undefined) => {
        if (valores.every(function (item) { return item === undefined || item === '' || item === 'nenhum' })) {// se nenhum campo foi preenchido
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha ao menos um índice" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        } else {
            handleCloseIndice();
            setRows([]);
            resetPaginacao();
            setIsLoading(true);
            var dadosIndice: Omit<IIndice_Documento, 'idDocumento'>[] = ConversorDeValorIndice.explodirParaFiltro(rowsIndice, valores);

            if (isNewPage) {
                DocumentoService.consultarPorIndices(selectedIdTipo, dadosIndice, pagina).then(result => {
                    setIsLoading(false);
                    if (result instanceof Error) {//verificar se deu erro
                        setIsLoading(false);
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    }
                    else {
                        setRows(result.documentos)
                        setPaginacao(result.paginacao);
                        setEscolha("indices");
                    }
                });
            } else {
                resetPaginacao();
                limparCamposPesquisa();
                setSearchParams({ pagina: "1" }, { replace: true });

                DocumentoService.consultarPorIndices(selectedIdTipo, dadosIndice, 1).then(result => {
                    setIsLoading(false);
                    if (result instanceof Error) {//verificar se deu erro
                        setIsLoading(false);
                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);
                    }
                    else {
                        setRows(result.documentos)
                        setPaginacao(result.paginacao);
                        setEscolha("indices");
                    }
                });
            }

        }
    }

    const handlePesquisarPorCodBarrasOuLocalizador = (isNewPage: boolean | undefined) => {
        const page = isNewPage ? pagina : 1;

        if (localStorage.getItem("cnpj") !== null && localStorage.getItem("cnpj") !== undefined && localStorage.getItem("cnpj") !== "") {
            setRows([]);
            resetPaginacao();
            setIsLoading(true);
            DocumentoService.consultarPorLocalizador(localizador, page, codBarras).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {//verificar se deu erro
                    setIsLoading(false);
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setRows(result.documentos)
                    setPaginacao(result.paginacao);
                    setEscolha("localizador");
                }
            });
        } else {
            setTextoBusca("");
            setSearchParams({ pagina: "1" }, { replace: true })
            DocumentoService.consultarPorLocalizador(localizador, page, codBarras).then(result => {
                setIsLoading(false);
                if (result instanceof Error) {//verificar se deu erro
                    setIsLoading(false);
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                }
                else {
                    setRows(result.documentos)
                    setPaginacao(result.paginacao);
                    setEscolha("localizador");
                }
            });
        }
    }

    const handleConsultarPorTexto = (texto: string, isNewPage: boolean | undefined) => {
        if (localStorage.getItem('cnpj') !== null && localStorage.getItem('cnpj') !== "") {
            if (texto === '') {

                setHelperTextTextoBusca(true);

            } else {

                setRows([]);
                resetPaginacao();
                setIsLoading(true);

                if (isNewPage) {

                    //no service troca o & comercial para que não seja identificado como queryString
                    DocumentoService.consultarPorTexto(texto, localStorage.getItem('cnpj') ?? "", Number(localStorage.getItem('idUnidade') ?? 0), Number(localStorage.getItem('idSetor') ?? 0), selectedIdTipo, pagina).then(result => {

                        setIsLoading(false);

                        if (result instanceof Error) {//verificar se deu erro

                            setIsLoading(false);
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        }
                        else {

                            setRows(result.documentos)
                            setPaginacao(result.paginacao);
                            setEscolha("textual");

                        }
                    });

                } else {
                    setLocalizador("");
                    setSearchParams({ pagina: "1" }, { replace: true });
                    DocumentoService.consultarPorTexto(texto, localStorage.getItem('cnpj') ?? "", Number(localStorage.getItem('idUnidade') ?? 0), Number(localStorage.getItem('idSetor') ?? 0), selectedIdTipo, 1).then(result => {
                        setIsLoading(false);
                        localStorage.removeItem("stringBusca")
                        if (result instanceof Error) {//verificar se deu erro

                            setIsLoading(false);
                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        }
                        else {

                            setRows(result.documentos)
                            setPaginacao(result.paginacao);
                            setEscolha("textual");

                        }
                    });

                }

            }
        } else {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione uma área" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);

            setRows([]);
            resetPaginacao();

        }
    }

    const handleAbrirPdf = async (idDocumento: number, index: number) => {

        setIsOpening((prev) => {
            const aux = [...prev];
            aux[index] = true;
            return aux;
        });

        // Zera progresso inicial para o item
        setProgressLoading((prev) => {
            const aux = [...prev];
            aux[index] = 0;
            return aux;
        });

        const resultado = await DocumentoService.pesquisarDoc(idDocumento, (progress) => {
            setProgressLoading((prev) => {
                const aux = [...prev];
                aux[index] = progress;
                return aux;
            });
        });

        if (resultado instanceof Error) {
            setAlertSnackbar({ tipoAlert: "erro", mensagem: resultado.message });
            setTimeout(() => setAlertSnackbar(undefined), duracaoAlert);
        } else {
            AbrirDocumento(resultado.blob, resultado.headers);
        }

        setIsOpening((prev) => {
            const aux = [...prev];
            aux[index] = false;
            return aux;
        });
    };


    const handleMesclar = (idDocumento: number) => {
        if (selectedFile) {
            setIsLoadingMesclar(true);
            const arquivo = new FormData();

            arquivo.append('arquivo', selectedFile);
            DocumentoService.mesclar(idDocumento, ordemAnexoFinal, arquivo).then(result => {
                setIsLoadingMesclar(false);
                handleCloseMesclar();
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Documentos mesclados" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                    setSelectedFile(undefined);
                    setIsFilePicked(false);

                    const row = (element: IDocumento) => element.idDocumento === idDocumento;
                    const index = rows.findIndex(row);

                    var aux = rows;

                    if (aux[index].localV2 === null) {
                        aux[index].localV2 = "";
                    } else {
                        aux[index].localV1 = "";
                    }

                }
            });
        } else {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Selecione um arquivo" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        }
    }

    const handleVoltarVersao = () => {
        DocumentoService.voltarVersao(selectedIdDoc).then(result => {
            handleCloseVoltarVersao();
            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Versão restaurada" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
                setSelectedFile(undefined);
                setIsFilePicked(false);

                const row = (element: IDocumento) => element.idDocumento === selectedIdDoc;
                const index = rows.findIndex(row);

                var aux = rows;

                if (aux[index].localV1 !== null) {
                    aux[index].localV1 = null;
                } else {
                    aux[index].localV2 = null;
                }

            }
        });
    }

    useEffect(() => {
        if (escolha === "indices") {
            handleConsultarPorIndices(true);
        }
        else if (escolha === "tipo") {
            handleConsultarPorIdTipo(true);
        }
        else if (escolha === "localizador") {
            handlePesquisarPorCodBarrasOuLocalizador(true);
        }
        else if (escolha === "textual") {
            handleConsultarPorTexto(textoBusca, true);
        }
    }, [pagina]);

    interface IPermissoes {
        role: string,
        abrir: boolean,
        mesclar: boolean,
        excluir: boolean,
        alterar: boolean
    }
    const [permissoes, setPermissoes] = useState<IPermissoes>({ role: "", abrir: false, mesclar: false, excluir: false, alterar: false });
    const [localStorageValue, setLocalStorageValue] = useState('');


    useEffect(() => {// toda vez que o token for mudado
        const token = localStorage.getItem("ACESS_TOKEN");
        //@ts-expect-error
        var decoded: TJwtToken = jwt_decode(token);
        setPermissoes({ role: decoded.role, abrir: decoded.Abrir, mesclar: decoded.Mesclar, excluir: decoded.Excluir, alterar: decoded.Alterar })

        setLocalStorageValue(localStorage.getItem("stringBusca") ?? "");

    }, []);

    useEffect(() => {
        if (localStorageValue) {
            handleConsultarPorTexto(localStorageValue, false);
            setTextoBusca(localStorageValue);
        }
    }, [localStorageValue])

    const [abrir, setAbrir] = useState(false);
    const [idToDelete, setidToDelete] = useState<number>(0);


    const handleClickDelete = (idDoc: number) => {
        setAbrir(true);
        setidToDelete(idDoc);
    }

    const handleCancel = () => {
        setAbrir(false);
    };

    const handleDelete = () => {
        setAbrir(false);
        setIsLoading(true);
        DocumentoService.desativar(idToDelete).then(result => {
            setIsLoading(false);

            if (result instanceof Error) {//verificar se deu erro
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setRows(oldRows => {
                    return [
                        ...oldRows.filter(oldRow => oldRow.idDocumento !== idToDelete),
                    ]
                });

                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Documento desativado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            }
        })
    }

    const [isOpening, setIsOpening] = useState(Array(rows.length).fill(false));

    const pegarNomeTipo = (rowsTipo: IListagemTipo[], idTipo: number): string => {
    var nome = rowsTipo.find(tipo => tipo.idTipo === idTipo)?.nomeTipo ?? "";

    if (nome === "") {
        for (let i = 0; i < rowsTipo.length; i++) {
        if (rowsTipo[i].tipos) {
            nome = pegarNomeTipo(rowsTipo[i].tipos, idTipo);
            if (nome !== "") {
            break;
            }
        }
        }
    }
    return nome;
    };

    const [abrirIndices, setAbrirIndices] = useState<boolean>(false);

    const exibirTodosIndices = () => {
        setAbrirIndices(!abrirIndices);
    }

    const [ordemAnexoFinal, setOrdemAnexoFinal] = useState<boolean>(false)


    const [openSendEmail, setOpenSendEmail] = useState(false);
    const [destinatario, setDestinatario] = useState("");
    const [assunto, setAssunto] = useState("");
    const [corpo, setCorpo] = useState("");

    const handleClickSendEmail = (nomeArquivo: string) => {
        var arrayNome = nomeArquivo.split("\\");
        setAssunto(arrayNome[arrayNome.length - 1]);
        setCorpo("");
        setOpenSendEmail(true);
    };

    const handleSendEmail = () => {

        if (assunto !== "" && corpo !== "" && destinatario !== "") {
            setIsLoading(true);

            var email: IEmail = { destinatario: destinatario, assunto: assunto, corpo: corpo };

            DocumentoService.enviarEmail(email).then((result) => {
                setIsLoading(false);

                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    // setDestinatario("");
                    // setAssunto("");
                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Email enviado com sucesso!" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                    setOpenSendEmail(false);
                }
            })
        }
        else {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha todos os campos" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
        }
    }

    return (
        <LayoutBaseDePagina titulo="Consultar documentos" barraDeFerramentas={
            <>
                <Box
                    component={Paper}
                    height={theme.spacing(5)}
                    marginX={1}
                    padding={1}
                    paddingX={2}
                    display="flex"
                    gap={1}
                    marginBottom={theme.spacing(1)}
                    alignItems="center"
                >
                    {alertSnackbar !== undefined && (
                        <>
                            {alertSnackbar.tipoAlert === "sucesso" && (
                                <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                            {alertSnackbar.tipoAlert === "erro" && (
                                <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                            {alertSnackbar.tipoAlert === "aviso" && (
                                <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                        </>
                    )}

                    <DialogConfirm
                        AoConfirmar={handleDelete}
                        titulo={"Deseja realmente excluir o documento?"}
                        texto={"Ao confirmar, não será possível recupera-lo."}
                        abrir={abrir}
                        AoCancelar={handleCancel}
                    />

                    <AutoCompleteDeSetor selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} />
                    <Button variant="contained" onClick={handleClickOpenTipo} disabled={isLoading || !idSetor}>
                        <Typography variant='button' noWrap> Mostrar Tipos  </Typography>
                    </Button>
                    
                    <ListagemTipos
                        abrir={openDialogTipo}
                        setRowsTipo={(rows) => setRowsTipo(rows)}
                        idSetor={parseInt(idSetor?.toString() || '0', 0)}
                        AoCancelar={handleCloseTipo}
                        AoConfirmar={handleCloseTipo}
                        handleConsultarPorIdTipo={() => handleConsultarPorIdTipo(false)}
                        setIdTipo={(idTipo) => setSelectedIdTipo(idTipo)}
                        txtTooltip='Para que um tipo seja listado aqui, é necessário que tenha no mínimo 1 (um) índice de DOCUMENTO'
                    />

                    <AlterarTipo 
                        abrir={migracao}
                        idSetor={idSetor ?? 0}
                        idDocumento={selectedIdDoc}
                        idTipoOrigem={idTipoOrigemMigracao}
                        indicesDocumentoOrigem={rows.find((row) => row.idDocumento === selectedIdDoc)?.indice_documentos ?? []}
                        AoConfirmar={handleConfirmarAlterarTipo}
                        AoCancelar={() => {
                            setMigracao(false);
                            setIdTipoOrigemMigracao(0);
                        }}
                     />
                    {!!selectedIdTipo && selectedIdTipo !== 0 && !!idSetor &&
                        <>

                            <Button variant="contained" onClick={handleClickOpenIndice} disabled={isLoading}>
                                <Typography variant='button' noWrap> Índices  </Typography>
                            </Button>

                            <Typography> Tipo Selecionado: <b> {pegarNomeTipo(rowsTipo, selectedIdTipo)} </b> </Typography>

                        </>
                    }


                    <Dialog
                        open={openDialogIndice}
                        onClose={handleCloseIndice}
                        fullWidth
                        maxWidth={'md'}
                    >
                        <DialogTitle> Índices </DialogTitle>
                        <DialogContent dividers>
                            {isLoadingIndice ? (
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <Box>
                                    <IndicesCadastro
                                        rowsAlterarValorIndice={rowsIndice}
                                        onValoresAlterarChange={setValores}
                                        reset={resetIndices}
                                        comOpcaoNenhumEmRadioESelect
                                        aoSalvar={() => handleConsultarPorIndices(false)}
                                    />
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Box
                                width="100%"
                                marginX={1}
                                padding={1}
                                paddingX={2}
                                gap={1}
                                display="flex"
                                justifyContent="center"
                            >
                                <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleCloseIndice}>
                                    <Typography variant='button' noWrap>Fechar </Typography>
                                </Button>
                                <Button variant="contained" startIcon={<Icon>search</Icon>} onClick={() => handleConsultarPorIndices(false)} disabled={isLoading}>
                                    <Typography variant='button' noWrap> Consultar por índices </Typography>
                                </Button>
                            </Box>
                        </DialogActions>
                    </Dialog>

                </Box>
                <Box
                    component={Paper}
                    height={theme.spacing(5)}
                    marginX={1}
                    padding={1}
                    paddingX={2}
                    display="flex"
                    gap={1}
                    alignItems="center"
                >
                    <CampoTextoMascarado
                        size="small"
                        mask={tipoMascara}
                        label="Localizador"
                        placeholder="Digite o localizador..."
                        disabled={isLoading}
                        error={helperTextLocalizador}
                        value={localizador}
                        onChange={(valorMascarado) => handleChangeLocalizador(valorMascarado)}
                        onKeyDown={() => setHelperTextLocalizador(false)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                setCodBarras('');
                                handlePesquisarPorCodBarrasOuLocalizador(false);
                                e.preventDefault();
                            }
                        }}
                        InputProps={{
                            endAdornment:
                                <>

                                    <ClickAwayListener onClickAway={handleTooltipMascaraClose}>
                                        <div>

                                            <HtmlTooltip PopperProps={{ disablePortal: true, }} onClose={handleTooltipMascaraClose} open={showTooltipMascara} disableFocusListener disableHoverListener disableTouchListener arrow title={
                                                <React.Fragment>

                                                    <FormControl>

                                                        <FormLabel> Tipo de Localizador </FormLabel>

                                                        <RadioGroup
                                                            row
                                                            value={tipoMascara}
                                                            onChange={(event) => {

                                                                setLocalizador('');
                                                                setTipoMascara(event.target.value);

                                                                setTimeout(() => {

                                                                    handleTooltipMascaraClose();

                                                                }, 500);

                                                            }}
                                                        >

                                                            <FormControlLabel value="aa9-999-a-999" control={<Radio />} label="aa9-999-a-999" />
                                                            <FormControlLabel value="aa9-999-aa-999" control={<Radio />} label="aa9-999-aa-999" />

                                                        </RadioGroup>

                                                    </FormControl>

                                                </React.Fragment>
                                            }>

                                                <IconButton
                                                    edge="end"
                                                    onClick={handleTooltipMascaraOpen}
                                                >
                                                    <Icon color='primary'>settings</Icon>
                                                </IconButton>

                                            </HtmlTooltip>

                                        </div>
                                    </ClickAwayListener>

                                    <IconButton
                                        onClick={() => { setCodBarras(''); handlePesquisarPorCodBarrasOuLocalizador(false) }}
                                        edge="end"
                                    >
                                        <Icon color={helperTextLocalizador ? 'error' : 'primary'}>search</Icon>
                                    </IconButton>
                                </>
                        }}
                    />

                    <TextField size="small" label="Código de barras" placeholder="Digite o Código..." type="number" error={helperTextCodBarras}
                        disabled={isLoading}
                        onChange={(event) => setCodBarras(event.target.value)}
                        value={codBarras}

                        onKeyDown={(e) => {
                            setHelperTextCodBarras(false);

                            if (codBarras === "") {
                                setHelperTextCodBarras(true);
                            }
                            else if (e.key === 'Enter') {
                                setLocalizador('');
                                handlePesquisarPorCodBarrasOuLocalizador(false);
                                e.preventDefault();
                            }
                        }}
                        InputProps={{
                            endAdornment:
                                <IconButton
                                    onClick={() => { if (codBarras !== "") { setLocalizador(''); handlePesquisarPorCodBarrasOuLocalizador(false) } else { setHelperTextCodBarras(true) } }}
                                    edge="end"
                                >
                                    <Icon color='primary'>search</Icon>
                                </IconButton>
                        }}
                    />

                    <Grid width="50%">
                        <TextField size="small" fullWidth label="Busca textual" placeholder="Digite algo..." disabled={isLoading} error={helperTextTextoBusca}
                            onKeyDown={() => setHelperTextTextoBusca(false)}
                            value={textoBusca}
                            onChange={e => {
                                const inputValue = e.target.value;
                                if (inputValue.charAt(inputValue.length - 1) != ':') {
                                    setTextoBusca(e.target.value);
                                }
                            }}

                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    handleConsultarPorTexto(textoBusca, false);
                                    e.preventDefault();
                                }
                            }}
                            InputProps={{
                                endAdornment:
                                    <IconButton
                                        onClick={() => handleConsultarPorTexto(textoBusca, false)}
                                        edge="end"
                                    >
                                        <Icon color={helperTextTextoBusca ? 'error' : 'primary'}>search</Icon>
                                    </IconButton>
                            }}
                        />
                    </Grid>

                    <HtmlTooltip arrow title={
                        <React.Fragment>
                            <Typography color="inherit"> Operadores: </Typography>
                            & - e condicional <br />
                            | - ou condicional <br />
                            <br />
                            pesquisa com operadores traz todos os documentos que contém os texto que <u><b> satizfazem a condição desejada </b></u>, não importando a ordem dos elementos. Ex: "[...] Lucas [...] 04/06/2003 [...] aracaju"
                            <br /><br />
                            pesquisa sem operadores traz o <u><b> conjunto de caracteres de que sejam seguencias </b></u>. Ex: "[...] Lucas Santana [...]"
                        </React.Fragment>
                    }>
                        <Icon color='primary'> help_outline </Icon>
                    </HtmlTooltip>

                </Box>
            </>
        }>
            <Dialog
                open={openDialogAlterarValorIndice}
                onClose={handleCloseAlterarValorIndice}
                fullWidth
                maxWidth={'md'}
            >
                <DialogTitle> Índices </DialogTitle>
                <DialogContent dividers>
                    {isLoadingIndice ? (
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box>
                            <IndicesCadastro
                                rowsAlterarValorIndice={rowsAlterarValorIndice}
                                initialValues={valoresAlterar}
                                onValoresAlterarChange={setValoresAlterar}
                                aoSalvar={handleSaveAlterarIndices}
                            />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Box
                        width="100%"
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        gap={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleCloseAlterarValorIndice}>
                            <Typography variant='button' noWrap> Fechar </Typography>
                        </Button>
                        <Button variant="contained" startIcon={isLoadingAlterarValorIndice ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : <Icon>save</Icon>} onClick={handleSaveAlterarIndices} disabled={isLoadingAlterarValorIndice}>
                            <Typography variant='button' noWrap> Salvar </Typography>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openSendEmail}
                onClose={() => setOpenSendEmail(false)}
                fullWidth
                maxWidth={'md'}
            >
                <DialogTitle> Enviar por email </DialogTitle>
                <DialogContent dividers>
                    <Grid marginY={2}>
                        <TextField fullWidth label="Destinatário" placeholder="Digite algo..." disabled={isLoading} margin='dense' type='email' onChange={(e) => setDestinatario(e.target.value)} />
                        <TextField fullWidth label="Assunto do email" placeholder="Digite algo..." disabled={isLoading} margin='dense' value={assunto} />
                        <TextField fullWidth label="Corpo do email" placeholder="Digite algo..." disabled={isLoading} margin='dense' multiline minRows={5} onChange={(e) => setCorpo(e.target.value)} />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box
                        width="100%"
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        gap={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={() => setOpenSendEmail(false)} disabled={isLoading}>
                            <Typography variant='button' noWrap> Voltar </Typography>
                        </Button>
                        <Button variant="contained" startIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : <Icon>forward_to_inbox</Icon>} onClick={handleSendEmail} disabled={isLoading}>
                            <Typography variant='button' noWrap> Enviar </Typography>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>


            <DialogConfirm
                AoConfirmar={handleVoltarVersao}
                titulo={"Dejesa realmente restaurar a versão do documento?"}
                texto={"Ao confirmar, a mesclagem do documento será desfeita e voltará uma versão"}
                abrir={openConfirmarVoltarVersao}
                AoCancelar={handleCloseVoltarVersao}
            />
            <Dialog
                open={openDialogMesclar}
                onClose={handleCloseMesclar}
            >
                <DialogTitle id="scroll-dialog-title"> Mesclar </DialogTitle>
                <DialogContent dividers>
                    <Grid container item direction="column" spacing={2} sx={{ mt: 3, mb: 3 }} textAlign={"center"}>

                        <Typography>Mesclar novo anexo no: </Typography>
                        <Box display="flex" gap={1} justifyContent="center">

                            <RadioGroup
                                key={"RadioGroup-ordem"}
                                row
                                value={ordemAnexoFinal}
                                onChange={(event) => { setOrdemAnexoFinal((event.target.value === "true" ? true : false)); }}
                            >
                                <FormControlLabel key={"inicio"} value={false} control={<Radio disabled={isLoading || isLoadingMesclar} />} label={"Início"} />
                                <FormControlLabel key={"final"} value={true} control={<Radio disabled={isLoading || isLoadingMesclar} />} label={"Final"} />
                            </RadioGroup>
                        </Box>

                        <Grid container item direction="row" spacing={2}>

                            <Grid item>
                                <Box display="flex" gap={1} alignItems="center">
                                    <Button
                                        variant="contained"
                                        component="label"
                                        disabled={isLoading || isLoadingMesclar}
                                    >
                                        <Typography variant='button' noWrap> Selecionar arquivo </Typography>
                                        <input
                                            type="file"
                                            accept='application/pdf'
                                            hidden
                                            onChange={handleArquivo}
                                        />
                                    </Button>
                                    {isFilePicked ? (
                                        //@ts-expect-error
                                        <Typography> {selectedFile.name} </Typography>
                                    ) : (
                                        <Typography> Nenhum arquivo selecionado </Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box
                        width="100%"
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        gap={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button variant="contained" color="error" disabled={isLoadingMesclar} startIcon={<Icon>close</Icon>} onClick={handleCloseMesclar}>
                            <Typography variant='button' noWrap> Fechar </Typography>
                        </Button>
                        <Button variant="contained" disabled={isLoadingMesclar} startIcon={isLoadingMesclar ? (<CircularProgress size={20} />) : (<Icon>check</Icon>)} onClick={() => handleMesclar(selectedIdDoc)}>
                            <Typography variant='button' noWrap> Confirmar </Typography>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>

                            <TableCell> # </TableCell>
                            <TableCell> Área </TableCell>
                            <TableCell> Setor </TableCell>
                            <TableCell> Tipo </TableCell>
                            <TableCell> Localizador </TableCell>
                            <TableCell> Código de barras </TableCell>
                            <TableCell> Índices <Button onClick={() => exibirTodosIndices()}> <Icon color={themeName == 'light' ? 'secondary' : 'primary'}> {abrirIndices ? "visibility_off" : "visibility"} </Icon> </Button> </TableCell>
                            <TableCell> Periodicidade </TableCell>
                            <TableCell align='center'> Ações </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {rows.map((row, index) => {
                            //@ts-expect-error
                            const dados = row.local?.split("\\")?.pop().replaceAll("_", " ").split(" - ");// pega o local, colca espaço nas palavras e transforma em vetor

                            var tipo = "";
                            for (let i = 3; i < dados.length - 1; i++) {
                                tipo += dados[i];
                                if (i < dados.length - 2) {// saber se está na ultima posição do for
                                    tipo += " > ";
                                }
                            }

                            var indices = "";

                            row.indice_documentos.map((indice_documento, index) => {
                                var valor: string = "";
                                if (indice_documento?.valor !== null && indice_documento?.valor !== '') {
                                    valor = indice_documento.valor + ", ";
                                }

                                if (indice_documento?.dataInicial !== null && indice_documento?.dataFinal !== null) {
                                    let dataInicial = indice_documento.dataInicial?.split("-").reverse().join("/");// transforma em array com base no "-", coloca na ordem contrária e adiciona "/" entre as posições
                                    let dataFinal = indice_documento.dataFinal?.split("-").reverse().join("/");// transforma em array com base no "-", coloca na ordem contrária e adiciona "/" entre as posições

                                    valor = dataInicial + " - " + dataFinal + ", ";
                                } else if (indice_documento?.dataInicial !== null && indice_documento?.dataFinal === null) {
                                    let dataInicial = indice_documento.dataInicial?.split("-").reverse().join("/");// transforma em array com base no "-", coloca na ordem contrária e adiciona "/" entre as posições

                                    valor = dataInicial + ", ";
                                }

                                if (index === row.indice_documentos.length - 1) {// se for a ultima posição da repetição
                                    valor = valor.replace(", ", "");
                                    if (valor === '') {
                                        indices = indices.substring(0, indices.length - 2);

                                    }
                                }

                                indices += valor;

                            });
                            return (
                                <TableRow key={row.idDocumento}>
                                    <TableCell> {((pagina - 1) * Environment.LIMITE_DE_LINHAS) + (index + 1)} </TableCell>
                                    <TableCell> {dados[1]} </TableCell>
                                    <TableCell> {dados[2]} </TableCell>
                                    <TableCell> {tipo} </TableCell>
                                    <TableCell> {(row.localizador === null || row.localizador.trim() === "") ? "-" : row.localizador} </TableCell>
                                    <TableCell> {(row.codBarras === undefined || row.codBarras === null || row.codBarras.trim() === "") ? "-" : row.codBarras} </TableCell>

                                    {!abrirIndices && (row.indice_documentos.length <= 2 ? (
                                        <TableCell> {indices} </TableCell>
                                    ) : (
                                        <TableCell>
                                            <HtmlTooltip arrow title={
                                                <React.Fragment>
                                                    <>{indices.split(", ").map((valorIndice, index) => {
                                                        return (<>
                                                            <p key={valorIndice + "-" + index}>{valorIndice}</p>
                                                        </>);
                                                    })}</>
                                                </React.Fragment>
                                            }>
                                                <Icon> more_horizon </Icon>
                                            </HtmlTooltip>
                                        </TableCell>

                                    ))}

                                    {abrirIndices &&
                                        <TableCell>
                                            <>
                                                {indices.split(", ").map((valorIndice, index) => {
                                                    return (<>
                                                        <p key={valorIndice + "-" + index}>{valorIndice}</p>
                                                    </>);
                                                })}
                                            </>
                                        </TableCell>
                                    }

                                    <TableCell>
                                        {(row.corrente.split("-")[0] > "1000" || row.intermediaria.split("-")[0] > "1000") ?
                                            <>
                                                <p key={row.corrente + "-" + index}>{row.corrente?.split("-").reverse().join("/")}</p>
                                                <p key={row.intermediaria + "-" + index}>{row.intermediaria?.split("-").reverse().join("/")}</p>
                                            </>
                                            :
                                            <> <Typography fontStyle={'italic'}> (Temporalidade não controlada) </Typography> </>
                                        }
                                    </TableCell>

                                    <TableCell align='center'>

                                        {(permissoes.abrir || permissoes.role === "master" || permissoes.role === "clienteGestor") &&
                                            <>

                                                {isOpening[index] === false || isOpening[index] === undefined ? (
                                                    <IconButton size="small" onClick={() => handleAbrirPdf(row.idDocumento, index)}>
                                                        <Tooltip arrow title="Abrir documento">
                                                            <Icon> description </Icon>
                                                        </Tooltip>
                                                    </IconButton>
                                                ) : (
                                                    <IconButton size="small" >
                                                        <Tooltip arrow title="Abrindo documento">
                                                            <CircularProgressWithLabel value={progressLoading[index]} size={30} />
                                                        </Tooltip>
                                                    </IconButton>
                                                )}
                                            </>
                                        }

                                        {(permissoes.mesclar || permissoes.role === "master" || permissoes.role === "clienteGestor") &&
                                            <IconButton size="small" onClick={() => {
                                                handleClickOpenMesclar();
                                                setSelectedIdDoc(row.idDocumento);
                                            }}>
                                                <Tooltip arrow title="Mesclar documento">
                                                    <Icon> difference </Icon>
                                                </Tooltip>
                                            </IconButton>
                                        }

                                        {row.localV2 !== null && (permissoes.mesclar || permissoes.role === "master" || permissoes.role === "clienteGestor") && (
                                            <IconButton size="small" onClick={() => {
                                                handleClickOpenVoltarVersao();
                                                setSelectedIdDoc(row.idDocumento);
                                            }}>
                                                <Tooltip arrow title="Restaurar versão">
                                                    <Icon> restore_page </Icon>
                                                </Tooltip>
                                            </IconButton>

                                        )}

                                        {(permissoes.alterar || permissoes.role === "master" || permissoes.role === "clienteGestor") &&
                                            <IconButton size="small" onClick={() => {
                                                setSelectedIdDoc(row.idDocumento);
                                                handleClickOpenAlterarValorIndice(row.idDocumento, row.idTipo);
                                            }}>
                                                <Tooltip arrow title="Alterar valor do índice">
                                                    <Icon>list</Icon>
                                                </Tooltip>
                                            </IconButton>
                                        }

                                        {(false && (permissoes.alterar || permissoes.role === "master" || permissoes.role === "clienteGestor")) &&
                                            <IconButton size="small" onClick={() => {
                                                handleClickOpenAlterarTipo(row.idDocumento, row.idTipo);
                                                
                                            }}>
                                                <Tooltip arrow title="Alterar tipo do documento">
                                                    <Icon>drive_file_move</Icon>
                                                </Tooltip>
                                            </IconButton>
                                        }

                                        {(permissoes.excluir || permissoes.role === "master" || permissoes.role === "clienteGestor") &&

                                            <IconButton size="small" onClick={() => {
                                                handleClickDelete(row.idDocumento);
                                            }}>
                                                <Tooltip arrow title="Apagar documento">
                                                    <Icon> delete </Icon>
                                                </Tooltip>
                                            </IconButton>

                                        }

                                        {(permissoes.abrir || permissoes.role === "master" || permissoes.role === "clienteGestor") &&

                                            <IconButton size="small" onClick={() => {
                                                handleClickSendEmail(row.local)
                                            }}>
                                                <Tooltip arrow title="Enviar por email">
                                                    <Icon> attach_email </Icon>
                                                </Tooltip>
                                            </IconButton>

                                        }

                                        {!permissoes.mesclar && !permissoes.mesclar && !permissoes.abrir && permissoes.role !== "master" && permissoes.role !== "clienteGestor" && (<Typography> sem ações disponíveis </Typography>)}
                                    </TableCell>
                                </TableRow>
                            )
                        })}

                    </TableBody>

                    {paginacao.totalCount === 0 && !isLoading && (
                        <caption> {Environment.LISTAGEM_VAZIA} </caption>
                    )}

                    <TableFooter>
                        {isLoading && (
                            <TableRow>
                                <TableCell colSpan={9}>{/* quantas colunas o loading vai ocupar */}
                                    <LinearProgress variant='indeterminate' />
                                </TableCell>
                            </TableRow>
                        )}
                        {paginacao.totalPages > 1 && (
                            <TableRow>
                                <TableCell colSpan={9} align="right">
                                    <Box flexDirection="row" display="inline-flex">
                                        <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                                        <Pagination
                                            page={pagina}
                                            count={paginacao?.totalPages}
                                            onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                                        />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableFooter>
                </Table>
            </TableContainer>
        </LayoutBaseDePagina >
    )
}
